import _ from "lodash";
import { Article, ProductGroup } from "../../api/schema";
import { UserLanguage } from "../../lang/lang";
import "./style.css";
import { ArticleRow } from "./ui";

interface ArticleListInterface {
  active_article: Article | null;
  set_article: (a: Article) => void;
  product_group: ProductGroup | null;
}

export const ArticleList = (props: ArticleListInterface) => {
  if (props.product_group) {
    if (props.product_group.articles.length > 0) {
      return (
        <div
          style={{
            gridTemplateColumns: "150px 100px minmax(150px, 250px) auto",
          }}
          className="article_list_grid"
        >
          {_.map(
            [
              UserLanguage().data.article.matchcode,
              UserLanguage().data.footprint.label,
              UserLanguage().data.article.label,
              UserLanguage().data.display_name,
            ],
            (v, k) => (
              <div key={"header_" + k} className="article_list_header">
                {v}
              </div>
            )
          )}
          {_.map(props.product_group.articles, (article) => (
            <ArticleRow
              article={article}
              selected={article.id === props.active_article?.id}
              onSelect={() => props.set_article(article)}
              key={article.id}
            />
          ))}
        </div>
      );
    } else
      return (
        <h4 style={{ marginLeft: 25 }}>
          {UserLanguage().pages.articleListView.no_items_in_category}
        </h4>
      );
  } else {
    return (
      <h4 style={{ marginLeft: 25 }}>
        {UserLanguage().pages.articleListView.select_category}
      </h4>
    );
  }
};
